module.exports = __webpack_public_path__ + "img/sponsorN27.639e7cc3.png";